import axios from 'axios';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

function list(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'groupname', 'kodecash', 'namacash'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/groupakuncf${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}

function save(data) {
    return new Promise(async (resolve, reject) => {
        try {
            await axios.post("groupakuncf", data);
            resolve();
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

function remove(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await axios.delete(`groupakuncf/${obj.groupkey}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

export default {
    list, 
    save,
    remove
};